import React, { useEffect } from "react"
import { InArticleSlots } from "../constants/ads"

export const Adsense = ({ path, inArticleConfig }) => {
  const index = inArticleConfig
  useEffect(() => {
    ;(window.adsbygoogle = window.adsbygoogle || []).push({})
  }, [path])

  if (typeof index === "number") {
    return (
      <ins
        className="adsbygoogle"
        style={{ display: "block", textAlign: "center", margin: "30px 0px" }}
        data-ad-layout="in-article"
        data-ad-format="fluid"
        data-ad-client="ca-pub-9666200095847888"
        data-ad-slot={InArticleSlots[index]}
      />
    )
  }

  return (
    <ins
      className="adsbygoogle"
      style={{ display: "block", textAlign: "center" }}
      data-ad-client="ca-pub-9666200095847888"
      data-ad-slot="9963272548"
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  )
}
